export default __webpack_public_path__ + "static/media/marshall-attack.1ad1ea0e.webp";